"use client";

import { c as _c } from "react/compiler-runtime";
import { IconShoppingCart } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/queries/useCart";
import { useNewCartStore } from "@/stores/useNewCartStore";
export function CartButton() {
  const $ = _c(5);
  const {
    data: cart
  } = useCart();
  const itemCount = cart?.items?.length ?? 0;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconShoppingCart className="size-5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== itemCount) {
    t1 = itemCount > 0 && <span className="absolute top-px right-px flex size-4 items-center justify-center rounded-full border border-white bg-primary text-[9px] font-bold text-primary-foreground">{itemCount}</span>;
    $[1] = itemCount;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Button variant="ghost" size="icon" aria-label="Open cart" className="relative" onClick={_temp}>{t0}{t1}</Button>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp() {
  return useNewCartStore.getState().setIsCartOpen(true);
}